import { Dialog, DialogContent, Box, Typography, Button } from "@mui/material";
import { useTranslations } from "next-intl";
import { IMAGES } from "@/lib/constants";
import Image from "next/image";

export default function ErrorModal({ visible, message, onClose }) {
   const t = useTranslations("creditScore");

  return (
    <Dialog
      open={visible}
     // onClose={onClose}
      onClose={(event, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
          return;
        }
        onClose();
      }}
      PaperProps={{
        sx: {
          borderRadius: 3,
          padding: 3,
          textAlign: "center",
          maxWidth: 350,
        },
      }}
    >
      <DialogContent>
        {/* Icon */}
        <Box sx={{ mb: 2 }}>
           <Image
                style={{
                transform: "scale(0.8)",
                }}
                src={IMAGES.securedDataImg}
                alt="Info Icon"
            />
        </Box>

        {/* Title */}
        <Typography
          variant="h6"
          sx={{ fontWeight: 600, mb: 1 }}
        >
          {t("unableRetrieveReportMsg")}
        </Typography>

        {/* Subtitle */}
        <Typography
          variant="body2"
          sx={{ color: "#555", mb: 3 }}
        >
          {/* {t("pleaseCheckDetails")} */}
          {message}
        </Typography>

        {/* Button */}
        <Button
          variant="contained"
          fullWidth
          onClick={onClose}
          sx={{
            background: "#004136",
            textTransform: "none",
            borderRadius: 2,
            paddingY: 1.2,
            fontWeight: 600,
            fontSize: 15,
          }}
        >
          {t("goBack")}
        </Button>
      </DialogContent>
    </Dialog>
  );
}
